import React from 'react';
import CreditMemoItem from '../../../Domain/CreditMemo/CreditMemoItem';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import CreditMemoService from '../../../Services/CreditMemo/CreditMemoService';
import CreditMemoSearchParams from './CreditMemoSearchParams';

export default class CreditMemoAdmin extends React.Component {
  static defaultProps = {
    clientInvoiceId: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      searchItem: new CreditMemoSearchParams(),
    };
    if (this.props.clientInvoiceId) {
      this.state.searchItem.ClientInvoiceId = this.props.clientInvoiceId;
      this.state.searchItem.SelectedOfficeIds = [];
    }
  }

  startSearch(searchItem) {
    this.setState({ searchItem: searchItem });
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={CreditMemoItem}
          serviceFunction={CreditMemoService.GetListBySearching}
          convertDBItemsFunction={CreditMemoService.ConvertDBItems}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Desc}
          showSearchStrip={!this.props.clientInvoiceId}
          searchParamsType={CreditMemoSearchParams}
          clickOnStartSearch={(searchItem) => this.setState({ searchItem })}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in Client ID/Name and Invoice ID...'
          errorCode='CMA41'
        />
      </div>
    );
  }
}
